import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

// TODO(ldemarne): Make a reusable component, add story, and update CellsRefinementOptions.

/*
 * Props.
 */

interface RefinementPillProps {
  isOpen: boolean;
  hasSelection: boolean;

  children?: ReactNode;
}

interface RefinementOptionStyleProps {
  $isOpen: boolean;
  $hasSelection: boolean;
}

/*
 * Styles.
 */

const StyledRefinementOptionDiv = styled.div<RefinementOptionStyleProps>`
  display: flex;
  gap: 4px;
  align-items: center;
  border-radius: 100px;
  padding: 2px 8px;
  overflow: hidden;
  ${(p) => addRefinementOptionStyles(p)};

  min-width: 0;
  max-width: 424px;
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};
`;

function addRefinementOptionStyles({$isOpen, $hasSelection}: RefinementOptionStyleProps) {
  if ($hasSelection && $isOpen) {
    return css`
      color: ${(p) => p.theme.greys.shade90};
      background: ${(p) => p.theme.palette.blue.hover30};
    `;
  }

  if ($hasSelection) {
    return css`
      color: ${(p) => p.theme.greys.shade90};
      background: ${(p) => p.theme.palette.blue.shade30};
      &:hover {
        background: ${(p) => p.theme.palette.blue.hover30};
      }
    `;
  }

  if ($isOpen) {
    return css`
      color: ${(p) => p.theme.greys.shade80};
      background: ${(p) => p.theme.alphas.gray10};
    `;
  }

  return css`
    &:hover {
      color: ${(p) => p.theme.greys.shade80};
      background: ${(p) => p.theme.alphas.gray10};
    }
  `;
}

/*
 * Component.
 */

export const RefinementPill: FC<RefinementPillProps> = (props) => {
  const {isOpen, hasSelection, children} = props;

  return (
    <StyledRefinementOptionDiv $isOpen={isOpen} $hasSelection={hasSelection}>
      <Icon name="filtersSmall" />
      {children}
      <Icon name="chevronDownTiny" />
    </StyledRefinementOptionDiv>
  );
};
